import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamEntrypointsListQuery } from "../graphql/queries";
import type {
  StreamEntrypointsListQueryType,
  StreamEntrypointsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamEntrypointsListQuery = (
  options?: QueryHookOptions<
    StreamEntrypointsListQueryType,
    StreamEntrypointsListQueryVariablesType
  >
) => {
  return useQuery<
    StreamEntrypointsListQueryType,
    StreamEntrypointsListQueryVariablesType
  >(StreamEntrypointsListQuery, options);
};
